import React from 'react';
import PropTypes from 'prop-types';

import api from 'api';
import { useRequest } from 'shared/hooks';
import { MAX_PAGE_SIZE } from 'utils/constants';
import Autocomplete from 'shared/components/forms/Autocomplete';

const HealthSystemSelect = ({
  placeholder = '-- Healthcare System --',
  networkType,
  ...moreProps
}) => {
  const { doRequest: fetchSystems, data: systemData } = useRequest(
    api.getHealthSystemNames,
  );

  React.useEffect(() => {
    const params = { pageSize: MAX_PAGE_SIZE };
    if (networkType) params.networkType = networkType;
    fetchSystems(params);
  }, [fetchSystems, networkType]);

  const systemOptions = React.useMemo(
    () => systemData?.healthSystems || [],
    [systemData],
  );

  return (
    <Autocomplete
      {...moreProps}
      placeholder={placeholder}
      options={systemOptions}
    />
  );
};

HealthSystemSelect.propTypes = {
  placeholder: PropTypes.string,
  networkType: PropTypes.string,
};

export default HealthSystemSelect;
